import React, { useContext, useState } from "react";
import DeleteIcon from "../../../images/deleteIcon.svg";
import { LuExternalLink } from "react-icons/lu";
import NoteView from "./NoteView";
import { deleteNotes } from "../../../Utils/localStore";
import NewNote from "./NewNote";
import ToastContext from "../../../context/toasterContex";


const PatientNotes = ({ notes, update }) => {
  const { toast } = useContext(ToastContext)
  const [view, setView] = useState(false);
  const [currentNote, setCurrentNote] = useState(null)
  const [openEdit, setOpenEdit] = useState(false)
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)
  const handleView = async (detailsObj) => {
    await setCurrentNote(detailsObj)
    return setView(true);
  };
  const closeView = () => {
    setView(false);
  };
  const handleDeleteAction = async () => {
    if (notes) {
      await deleteNotes(currentNote.localID)
        .then(resp => {
          toast.success('Record deleted successfully', { position: toast.POSITION.TOP_CENTER })
        })
      update()
      setShowDeleteDialog(false)
    }
  }

  const Notes = [
    {
      id: 1,
      title: "Appointment",
      createdAt: "Created on Monday 17 May, 2023 at 12:00 PM WAT",
    },
    {
      id: 2,
      title: "Injury issues",
      createdAt: "Created on Monday 17 May, 2023 at 12:00 PM WAT",
    },
    {
      id: 3,
      title: "Ante natal",
      createdAt: "Created on Monday 17 May, 2023 at 12:00 PM WAT",
    },
    {
      id: 4,
      title: "Surgery",
      createdAt: "Created on Monday 17 May, 2023 at 12:00 PM WAT",
    },
  ];

  return (
    <>
      {
        showDeleteDialog &&
        <dialog >
          <div className="w-full md:w-max lg:w-[300px] bg-white rounded-md p-8 border">
            <p className="text-center mb-6">Are you sure you want to delete this note?</p>
            <div className="flex justify-between">
              <button onClick={(e) => {
                e.preventDefault()
                handleDeleteAction()
              }} className="rounded-md text-white bg-primary p-2">
                Confirm
              </button>
              <button autoFocus className="p-2 border rounded border-red-400" onClick={(e) => {
                e.preventDefault()
                setShowDeleteDialog(false)
              }}>
                Cancel
              </button>
            </div>
          </div>
        </dialog>}
      <section className="w-full font-euclid-circular-a pr-12">
        <div className="flex justify-between items-center gap-14">
          <div className="w-[200px] h-0 border  border-stone-600 border-opacity-50" />
          <p className="text-stone-600 text-opacity-50 text-sm font-normal leading-[21px]">
            All Notes
          </p>
          <div className="w-[200px] h-0 border  border-stone-600 border-opacity-50" />
        </div>

        {/* Cards */}
        {
          notes && notes.length ?
            notes.map((note, index) => (
              <div
                key={note.localID + index}
                className="border-4 border-l-sky-500 border-t-0 border-b-0 border-r-0 pl-5 pt-3 mb-3"
              >
                <div className="flex flex-col gap-3 border-b-gray-200 border-b">
                  <h2 className="text-gray-600 text-lg font-semibold leading-7">
                    {note.title}
                  </h2>
                  <div className="flex items-center gap-5 justify-end cursor-pointer">
                    <div className="flex-col" >
                      <button onClick={() => {
                        setCurrentNote(note);
                        handleView(note)
                      }}>
                        <LuExternalLink size={25} className="opacity-90" strokeWidth={1} />
                        <p>View</p>
                      </button>
                    </div>
                    <div className="flex-col">
                      <button onClick={() => {
                        setCurrentNote(note);
                        setShowDeleteDialog(true)
                      }}>
                        <img src={DeleteIcon} alt="" />
                        <p>Delete</p>
                      </button>
                    </div>
                  </div>
                  <p>{note.date}</p>
                </div>
              </div>
            ))
            :
            <p className="w-full italic text-center my-10 text-gray-300">
              No records found
            </p>

        }

        {view && <NoteView onClose={closeView} details={currentNote} editNote={() => { setView(false); setOpenEdit(true); }} />}
        {openEdit && <NewNote details={currentNote} update={() => setOpenEdit(false)} onClose={() => setOpenEdit(false)} edit={true} toast={toast} />}
      </section>
    </>
  );
};

export default PatientNotes;
